module.exports = __webpack_public_path__ + "static/media/dialer.7dcddb12.png";